import { snapshot, useSnapshot as useSnapshotOrig } from 'valtio';

type SnapshotFunction = <T extends object>(p: T) => T;

const isSSR = typeof window === 'undefined';
const useSSRSnapshot = ((p) => snapshot(p)) as SnapshotFunction;

export const useSnapshot = isSSR ? useSSRSnapshot : useSnapshotOrig;
